"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.socialMedia.column.platform': 'Plataforma',
    'settings.socialMedia.column.status': 'Estado',
    'settings.socialMedia.x.title': 'X (Twitter)',
    'settings.socialMedia.x.description': 'Conecta tu cuenta de X para publicar.',
    'settings.socialMedia.x.connect': 'Conectar X',
    'settings.socialMedia.x.disconnect': 'Desconectar X',
    'settings.socialMedia.x.disconnected': 'X desconectado',
    'settings.socialMedia.x.connectFailed': 'Error al conectar X',
    'settings.socialMedia.x.disconnectFailed': 'Error al desconectar X',
    'settings.socialMedia.ig.title': 'Instagram',
    'settings.socialMedia.ig.description': 'Conecta tu cuenta de Instagram Business para publicar.',
    'settings.socialMedia.ig.connect': 'Conectar Instagram',
    'settings.socialMedia.ig.disconnect': 'Desconectar Instagram',
    'settings.socialMedia.ig.disconnected': 'Instagram desconectado',
    'settings.socialMedia.ig.connectFailed': 'Error al conectar Instagram',
    'settings.socialMedia.ig.disconnectFailed': 'Error al desconectar Instagram',
    'settings.socialMedia.fb.title': 'Facebook',
    'settings.socialMedia.fb.description': 'Conecta tu cuenta de Facebook para publicar.',
    'settings.socialMedia.fb.connect': 'Conectar Facebook',
    'settings.socialMedia.fb.disconnect': 'Desconectar Facebook',
    'settings.socialMedia.fb.disconnected': 'Facebook desconectado',
    'settings.socialMedia.fb.connectFailed': 'Error al conectar Facebook',
    'settings.socialMedia.fb.disconnectFailed': 'Error al desconectar Facebook',
    'settings.socialMedia.yt.title': 'YouTube',
    'settings.socialMedia.yt.description': 'Conecta tu canal de YouTube para publicar vídeos.',
    'settings.socialMedia.yt.connect': 'Conectar YouTube',
    'settings.socialMedia.yt.disconnect': 'Desconectar YouTube',
    'settings.socialMedia.yt.disconnected': 'YouTube desconectado',
    'settings.socialMedia.yt.connectFailed': 'Error al conectar YouTube',
    'settings.socialMedia.yt.disconnectFailed': 'Error al desconectar YouTube',
    'settings.socialMedia.tt.title': 'TikTok',
    'settings.socialMedia.tt.description': 'Conecta tu cuenta de TikTok para publicar vídeos.',
    'settings.socialMedia.tt.connect': 'Conectar TikTok',
    'settings.socialMedia.tt.disconnect': 'Desconectar TikTok',
    'settings.socialMedia.tt.disconnected': 'TikTok desconectado',
    'settings.socialMedia.tt.connectFailed': 'Error al conectar TikTok',
    'settings.socialMedia.tt.disconnectFailed': 'Error al desconectar TikTok',
    'settings.socialMedia.li.title': 'LinkedIn',
    'settings.socialMedia.li.description': 'Conecta tu cuenta de LinkedIn para publicar.',
    'settings.socialMedia.li.connect': 'Conectar LinkedIn',
    'settings.socialMedia.li.disconnect': 'Desconectar LinkedIn',
    'settings.socialMedia.li.disconnected': 'LinkedIn desconectado',
    'settings.socialMedia.li.connectFailed': 'Error al conectar LinkedIn',
    'settings.socialMedia.li.disconnectFailed': 'Error al desconectar LinkedIn',
    'settings.socialMedia.pt.title': 'Pinterest',
    'settings.socialMedia.pt.description': 'Conecta tu cuenta de Pinterest para publicar Pines.',
    'settings.socialMedia.pt.connect': 'Conectar Pinterest',
    'settings.socialMedia.pt.disconnect': 'Desconectar Pinterest',
    'settings.socialMedia.pt.disconnected': 'Pinterest desconectado',
    'settings.socialMedia.pt.connectFailed': 'Error al conectar Pinterest',
    'settings.socialMedia.pt.disconnectFailed': 'Error al desconectar Pinterest',
    'settings.socialMedia.th.title': 'Threads',
    'settings.socialMedia.th.description': 'Conecta tu cuenta de Threads para publicar contenido.',
    'settings.socialMedia.th.connect': 'Conectar Threads',
    'settings.socialMedia.th.disconnect': 'Desconectar Threads',
    'settings.socialMedia.th.disconnected': 'Threads desconectado',
    'settings.socialMedia.th.connectFailed': 'Error al conectar Threads',
    'settings.socialMedia.th.disconnectFailed': 'Error al desconectar Threads',
    'settings.socialMedia.dictionary.title': 'Diccionarios de Redes Sociales',
    'settings.socialMedia.dictionary.type': 'Tipo',
    'settings.socialMedia.dictionary.type.tone': 'Tono',
    'settings.socialMedia.dictionary.type.goal': 'Objetivo',
    'settings.socialMedia.dictionary.type.audience': 'Audiencia',
    'settings.socialMedia.dictionary.key': 'Clave',
    'settings.socialMedia.dictionary.label': 'Etiqueta',
    'settings.socialMedia.dictionary.icon': 'Icono',
    'settings.socialMedia.dictionary.order': 'Orden',
    'settings.socialMedia.dictionary.active': 'Activo',
    'settings.socialMedia.dictionary.add': 'Añadir',
    'settings.socialMedia.dictionary.edit': 'Editar',
    'settings.socialMedia.dictionary.delete': 'Eliminar',
    'settings.socialMedia.dictionary.editTitle': 'Editar elemento del diccionario',
    'settings.socialMedia.dictionary.addTitle': 'Añadir elemento al diccionario',
    'settings.socialMedia.dictionary.save': 'Guardar',
    'settings.socialMedia.dictionary.cancel': 'Cancelar',
    'settings.socialMedia.dictionary.loadFailed': 'Error al cargar los diccionarios',
    'settings.socialMedia.dictionary.fillRequired': 'Por favor complete todos los campos requeridos',
    'settings.socialMedia.dictionary.saved': 'Elemento del diccionario guardado',
    'settings.socialMedia.dictionary.saveFailed': 'Error al guardar el elemento del diccionario',
    'settings.socialMedia.dictionary.deleted': 'Elemento del diccionario eliminado',
    'settings.socialMedia.dictionary.deleteFailed': 'Error al eliminar el elemento del diccionario',
    'settings.socialMedia.dictionary.deleteConfirm': '¿Está seguro de que desea eliminar este elemento del diccionario?',
    'settings.socialMedia.dictionary.actions': 'Acciones',
};
